import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {
    // ConfirmationService,
    Message, MessageService} from 'primeng/api';
import {ContactTypeService} from '../../../../_services/contact-type-service';
import {ContactTypeResponse, GroupedRole} from '../../../../_models/contact-type.model';

import {Role} from '../../../../_models/contact-type.model';
import {Subscription} from 'rxjs';

@Component({
    selector: 'acabim-admin-contact-type-update',
    templateUrl: './update-contact-type.component.html',
    styleUrls: ['../contact-type.component.scss', './update-contact-type.component.scss']
})
export class ContactTypeUpdateComponent implements OnInit, OnDestroy {

    @Output() public completed = new EventEmitter<string>();
    @Input() public contactTypeDetails: ContactTypeResponse | null = null;
    loading = false;
    contactTypeForm: FormGroup | undefined;
    removeContactTypeModal = false;
    selectedRole: ContactTypeResponse | null = null;
    roleGroups: GroupedRole[] = [];
    roles: Role[] = [];
    roleCheckboxes: boolean[] = [];
    showStep1 = true;
    showStep2 = false;
    private _finalRoles: any[] = [];
    private _doSubmit = true;
    private _currentProcess: Subscription = new Subscription();
    private _rolesSub: Subscription = new Subscription();
    private _selectedRoleSub: Subscription = new Subscription();
    msgs: Message[] = [];

    constructor(
        private readonly logger: NGXLogger,
        private readonly messageService: MessageService,
        private contactTypeService: ContactTypeService,
        // private confirmationService: ConfirmationService
    ) {
        this._rolesSub = this.contactTypeService.getRoles().subscribe(r => {
            this.roleGroups = r.data;
            this.roleGroups.map(roleGroup => {
                roleGroup.roles.map(rc => {
                    this.roleCheckboxes[rc.id] = false;
                });
            });
            return r;
        });
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
        this._rolesSub.unsubscribe();
        this._selectedRoleSub.unsubscribe();
    }

    onRoleChange(roleId: number): void {
        this.roleCheckboxes[roleId] = !this.roleCheckboxes[roleId];
        this.makeFinalRoles();
    }

    private init(): void {
        this.loading = true;
        this._rolesSub = this.contactTypeService.getRoles().subscribe(r => {
            this.roleGroups = r.data;
            this.roleGroups.map(roleGroup => {
                roleGroup.roles.map(rc => {
                    this.roleCheckboxes[rc.id] = false;
                });
            });
            const contactTypeId = this.contactTypeDetails?.id;
            if (contactTypeId) {
                this._selectedRoleSub = this.contactTypeService.getContactType(contactTypeId).subscribe(
                    ct => {
                        this.selectedRole = ct;
                        if (this.selectedRole && this.selectedRole.roles) {
                            this.selectedRole.roles.map(role => {
                                this.roleCheckboxes[role] = true;
                            });
                        }
                        this.initForm();
                        this.loading = false;
                    }
                );
            }
            return r;
        });
    }

    private initForm(): void {
        if (this.selectedRole != null) {
            const formRoles = new FormArray([]);
            if (this.selectedRole.roles) {
                // this.selectedRole.roles.map(roleId => {
                //     this.roleCheckboxes[roleId] = true;
                //     formRoles.push(new FormControl(roleId));
                // });
            }
            this.contactTypeForm = new FormGroup({
                name: new FormControl(this.selectedRole.name, Validators.required),
                description: new FormControl(this.selectedRole.description),
                status: new FormControl(this.selectedRole.status > 0),
                roles: formRoles
            });
        }
    }

    onContactTypeUpdateSubmit(): void {
        this.loading = true;
        if (typeof this.contactTypeForm !== 'undefined') {
            // const roles: FormArray = this.contactTypeForm.get('roles') as FormArray;
            // this._finalRoles = [...new Set(roles.value)];
            if (this._doSubmit) {
                this.upsertContactType();
            }
        }
    }

    makeFinalRoles(): void {
        this._finalRoles = [];
        this.roleCheckboxes.map((r, i) => {
            if(r) {
                this._finalRoles.push(i);
            }
        });
    }

    onContactTypeDeleteSubmit(): void {
        this.removeContactTypeModal = true;
        // this.confirmationService.confirm({
        //     message: 'Are you sure that you want to proceed?',
        //     header: 'Confirmation',
        //     icon: 'pi pi-exclamation-triangle',
        //     accept: () => {
        //         this.onContactTypeDeleteConfirmed();
        //     },
        //     reject: () => {
        //         this.onRejectDeletion();
        //     }
        // });
    }

    onRejectDeletion(): void {
        this.messageService.clear();
    }

    onContactTypeDeleteConfirmed(): void {
        this.loading = true;
        if (this.contactTypeForm) {
            // const roles: FormArray = this.contactTypeForm.get('roles') as FormArray;
            // this._finalRoles = [...new Set(roles.value)];
            if (this._doSubmit && this.contactTypeDetails) {
                this._currentProcess = this.contactTypeService.deleteContactType(this.contactTypeDetails.id).subscribe(
                    result => {
                        this.completed.emit('deleted');
                        this.loading = false;
                    }
                );
                this.upsertContactType();
            }
        }
    }

    go(step: number): void {
        if (this.contactTypeForm) {
            if (step === 1) {
                this.showStep2 = false;
                this.showStep1 = true;
            } else if (step === 2 && (this.contactTypeForm.value.name === null || this.contactTypeForm.value.name.length < 4)) {
                const message = 'Please enter a proper contact type name before continuing.';
                this.messageService.add({key: 'contactTypeNameMissing', severity: 'error', summary: message});
            } else if (step === 2 && this.contactTypeForm.value.name.length > 3) {
                this.messageService.clear('contactTypeNameMissing');
                this.showStep1 = false;
                this.showStep2 = true;
            }
        }
    }

    private upsertContactType(): void {
        if (this.contactTypeForm && this.contactTypeDetails) {
            this.makeFinalRoles();
            this.logger.debug('[ContactTypeUpdateComponent] Updating exiting contact type');
            this._currentProcess = this.contactTypeService.upsertContactType(
                this.contactTypeForm.value.name,
                this.contactTypeForm.value.description,
                this.contactTypeForm.value.status ? 1 : 0,
                this._finalRoles,
                this.contactTypeDetails.id.toString()
            ).subscribe(newContactType => {
                this.logger.debug('[ContactTypeUpdateComponent] Contact type updated successfully: ', newContactType.id);
                this.initForm();
                this.completed.emit('updated');
                this.loading = false;
            }, (error: any) => {
                this.logger.debug('[ContactTypeUpdateComponent] Contact type failed to update');
                this.logger.error(error);
                this.loading = false;
            });
        }
    }

    onCancel(): void {
        this.logger.debug('[ContactTypeAddComponent] Add Contact type modal Cancelled');
        this.completed.emit('cancelled');
    }

    setRemoveContactTypeModal(value: any): void {
        this.removeContactTypeModal = value;
    }

    onRemoveCompletion(value: any): void {
        if (value === 'completed' && this.contactTypeDetails) {
            this.init();
            this.completed.emit('updated');
        }
        this.removeContactTypeModal = false;
    }
}
